import { Button, Form, Modal, notification } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import { getRoomById, updateRoomById } from "store/slices/roomsSlice";
import { getSchools } from "store/slices/schoolsSlice";
import RoomForm from "./room-form";
const EditRoomModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { room, loading } = useSelector((state) => state?.rooms);
  const { schools } = useSelector((state) => state?.schools);
  const { userData } = useSelector((state) => state?.auth);
  const open = isModalOpen && modalType === "edit_room";

  useEffect(() => {
    if (open) dispatch(getSchools(userData?._id));
  }, [dispatch, open]);

  useEffect(() => {
    if (modalProps?.roomId && open) {
      dispatch(getRoomById(modalProps?.roomId));
    }
  }, [dispatch, modalProps?.roomId, open]);

  useEffect(() => {
    if (room && open && modalProps?.roomId) {
      form?.setFieldsValue({
        ...room,
      });
    } else if (!room) {
      form?.resetFields();
    }
  }, [form, room, open]);

  const onSubmit = async (values) => {
    try {
      await dispatch(
        updateRoomById({
          id: modalProps?.roomId,
          data: values,
        })
      )?.unwrap();
      onClose();
    } catch (error) {
      notification?.error({
        message: t("rooms.crud.form.error.failed"),
        description: error,
        role: "alert",
        duration: 3,
      });
    }
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={<h4 style={{ textAlign: "center" }}>{t("rooms.crud.form")}</h4>}
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("rooms.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="room_form"
          disabled={loading}
        >
          {t("rooms.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <RoomForm form={form} onSubmit={onSubmit} schools={schools} />
    </Modal>
  );
};

export default EditRoomModal;
